<template lang="html">
  <div class="col-lg-9 col-page-content page-style-1">

    <div class="row box-panel-top">
      <div class="col-lg-12 col-l">
        <h5 class="box-title">PANEL</h5>

        <div class="box-panel-info">
          <div class="col col-s1">
            <h6 class="title">Vacantes Publicadas</h6>
            <h4 class="num">{{$root.user.vacancies.length}}</h4>
            <h6 class="title-2">Vacantes disponibles para emplear</h6>
          </div>

          <div class="col col-s2">
            <h6 class="title">Perfiles guardados</h6>
            <h4 class="num">{{$root.user.total_favorites}}</h4>
            <h6 class="title-2">Candidatos guardados por ti</h6>
          </div>

          <div class="col col-s3">
            <h6 class="title">Mensajes sin leer</h6>
            <h4 class="num">{{$root.user.messages.length}}</h4>
            <h6 class="title-2">Nuevos mensajes sin leer en tu bandeja</h6>
          </div>

          <div class="col col-s4">
            <h6 class="title">Vacantes restantes</h6>
            <h4 class="num">1</h4>
            <h6 class="title-2"><router-link :to="{ name: 'compAccPlans' }">Consulta los paquetes</router-link></h6>
          </div>
        </div>
      </div>

      <!-- <div class="col-lg-3 pl-lg-0 col-r">
        <h6 class="box-title">NOTIFICACIONES ACTIVADAS</h6>
      </div> -->
    </div>

    <div class="row box-candidates">
      <div class="col-12 col-button">
        <a class="btn-squ-cur-1 xl btn-post" href="#/cuenta-empresa/publicar-vacante">Publicar Nueva Vacante</a>
      </div>

      <!-- Candidatos que aplicaron recientemente -->
      <div class="col-12 col-candidates-list">
        <div class="row">

          <div class="col-12 box-acc-title-s1">
            <h4>Candidatos que aplicaron recientemente</h4>
          </div>

          <div class="col-12 col-candidate-s2" v-for="(recently, cand1Inx) in $root.user.postulates_recently" :key="'cand1Inx-'+cand1Inx">
            <div class="box">
              <div class="col-vac-info">
                <div>
                  <span>Vacante: <u class="limit">{{recently.vacant}}</u></span>
                  <span>Fecha de aplicación: {{recently.creado}}</span>
                  <span>Sueldo deseado: {{recently.sueldodeseado}} {{recently.sueldodeseado_periodo}}</span>
                  <!-- <span>Sueldo deseado: $18,500 mes</span> -->
                </div>

              </div>

              <div class="col col-photo">
                <div class="img" v-bind:style="{ backgroundImage: 'url('+recently.imageUrl+')' }"></div>
              </div>

              <div class="col col-info">
                <h4 class="name"><a target="_blank" :href="'https://jobusco.com/#/perfil-candidato/'+$root._converToURL(recently.name, recently.usuarios_id)">{{recently.name}}</a></h4>
                <h5>
                  <!-- <span class="career">Asesor de Ventas</span><br /> -->
                  <i class="loc-icon"></i><span class="location">{{recently.town}}, {{recently.state}}</span>
                </h5>
              </div>

              <div class="col-12 col-line">
                <hr />
              </div>

              <div class="col col-2ndbuttons">
                <a class="btn-msg" :href="'mailto:'+recently.email">
                  <img src="public/images/pages/account/icon-messages-active.png">
                  <span>enviar mensaje</span>
                </a>

                <a class="btn-profile"  target="_blank" :href="'https://jobusco.com/#/perfil-candidato/'+$root._converToURL(recently.name, recently.usuarios_id)">
                  <i class="far fa-eye icon"></i>
                  <span>Ver Perfil</span>
                </a>
              </div>



              <div class="col col-buttons">
                <button class="trans-250 btn-squ-1 form-control" @click="savePostulate(recently.usuarios_id,recently.vacant_id)" v-if="recently.favorite == 0">Guardar candidato</button>
                <button class="trans-250 btn-squ-1 form-control" @click="savePostulate(recently.usuarios_id,recently.vacant_id)" v-else style="background-color: #1327ca;border-color:#1327ca">Guardado</button>

                <!-- <a class="trans-250 btn-squ-1 gray">descartar</a> -->
                <button class="trans-250 btn-squ-1 gray form-control" @click="deletePostulate(recently.usuarios_id,recently.vacant_id)" >Descartar</button>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--  -->

      <!-- Últimos perfiles guardados -->
      <div class="col-12 col-candidates-list">
        <div class="row">

          <div class="col-12 box-acc-title-s1">
            <h4>Últimos perfiles guardados</h4>
          </div>

          <div class="col-12 col-candidate-s2 mb-3" v-for="(postulate, cand1Inx) in $root.user.favorites_recently" :key="'cand1Inx-'+cand1Inx">
            <div class="box">
              <a class="btn-del"@click="deleteFavorite(postulate.id)">x</a>

              <div class="col col-photo">
                <div class="img" v-bind:style="{ backgroundImage: 'url('+postulate.imageUrl+')' }"></div>
              </div>

              <div class="col col-info">
                <h4 class="name"><a target="_blank" :href="'https://jobusco.com/#/perfil-candidato/'+postulate.usuarios_id">{{postulate.name}}</a></h4>
                <h5>
                  <!-- <span class="career">Agente de seguros</span><br /> -->
                  <i class="loc-icon"></i><span class="location">{{postulate.town}}, {{postulate.state}}.</span>
                </h5>
              </div>

              <div class="col-12 col-line">
                <hr />
              </div>

              <div class="col col-2ndbuttons lg">
                <a class="btn-msg" :href="'mailto:'+postulate.email">
                  <img src="public/images/pages/account/icon-messages-active.png">
                  <span>enviar mensaje</span>
                </a>

                <a class="btn-profile"  target="_blank" :href="'https://jobusco.com/#/perfil-candidato/'+postulate.usuarios_id">
                  <i class="far fa-eye icon"></i>
                  <span>Ver Perfil</span>
                </a>

                <a class="btn-profile linkedin" :href="postulate.linkedin" target="_blank">
                  <img src="public/images/pages/account/linkedin.png">
                  <span>Visitar Perfil</span>
                </a>
              </div>

              <div class="col col-buttons">
                <a class="trans-250 btn-squ-cur-1 outline-aqua-text btn-HelvNeu" @click="downloadcv(postulate.usuarios_id)">Descargar CV <i class="fas fa-caret-down"></i></a>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!--  -->
      <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
      </sweet-modal>
      <sweet-modal ref="modalAlert" :icon="modal.icon">
          <p>{{modal.msg}}</p>
           <br><br>
          <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
      </sweet-modal>
    </div>

  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
export default {
  data(){
    return{
        modal:{
          icon:null,
          msg:null
        }
    }
  },

  methods: {

      savePostulate(usuarios_id,vacant_id){
            var data = {
              'usuarios_id':usuarios_id,
              'vacant_id':vacant_id
            };
           axios.post(tools.url("/api/admin/saveFavoritePostulateFront"),data).then((response)=>{
              this.$root.auth();
              if(this.$route.params.id){
                //this.getDataByVacant();
              }
              else{
                  //this.getData();
              }

              this.$refs.modalLoading.close();
              this.modal.icon = 'success';
              this.modal.msg = 'Información actualizada correctamente';
              this.$refs.modalAlert.open();


          }).catch((error)=>{
              this.$refs.modalLoading.close();
              this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al guardar la información';
              this.$refs.modalAlert.open();

          });
      },
      deletePostulate(usuarios_id,vacant_id){
          var data = {
              'usuarios_id':usuarios_id,
              'vacant_id':vacant_id
            };
           axios.post(tools.url("/api/admin/deleteFavoritePostulateFront"),data).then((response)=>{
              this.$root.auth();
              if(this.$route.params.id){
                //this.getDataByVacant();
              }
              else{
                  //this.getData();
              }
              this.$refs.modalLoading.close();
              this.modal.icon = 'success';
              this.modal.msg = 'Información actualizada correctamente';
              this.$refs.modalAlert.open();


          }).catch((error)=>{
              this.$refs.modalLoading.close();
              this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al guardar la información';
              this.$refs.modalAlert.open();

          });
      },
      deleteFavorite(id){
        this.$refs.modalLoading.open();
        axios.delete(tools.url("/api/admin/deleteFavoritePostulate/"+id))
        .then((response)=>{
              this.$refs.modalLoading.close();
              this.modal.icon = 'success';
              this.modal.msg = 'Cantidato eliminado de favoritos';
              this.$refs.modalAlert.open();
              this.$root.auth();

          }).catch((error)=>{
              this.$refs.modalLoading.close();
              this.modal.icon = 'error';
              this.modal.msg = 'Ocurrio un error al obtener la información';
              this.$refs.modalAlert.open();
          });


      },
      downloadcv(id){
          axios.get(tools.url("/downloadCvPostulate/"+id)).then((response)=>{
              console.log(response);
              window.open(response.data,'_blank');
          }).catch(()=>{});
      }

  },
  mounted(){
      this.$root.auth();
  },

}
</script>
